// extracted by mini-css-extract-plugin
export default {"modalRoot":"I5oIvV","focusTrap":"EGo10J"};